import Keycloak from 'keycloak-js'
import getEnvConfig from 'utils/getEnvConfig'

const keycloak = (): Keycloak.KeycloakInstance => {
    const envConfig = getEnvConfig()
    return new Keycloak({
        url: envConfig.Keycloak.URL,
        realm: envConfig.Keycloak.Realm,
        clientId: envConfig.Keycloak.ClientID,
    })
}

export default keycloak
